export const TIME_FORMAT = "h:mm aaaa";
export const MEDAL = "medal";
export const TEAM_CA = "team-canada";
